import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { IconButton, TextField } from "@mui/material";
import { SxProps } from "@mui/system";

type Props = {
  sx?: SxProps;
  value: number;
  buttonColor?: string;
  min?: number;
  max?: number;
  size?: "small" | "medium";
  fullWidth?: boolean;
  defaultValue?: number;
  onChange: (value: number) => void;
  disabled?: boolean;
  isHidden?: boolean;
  error?: boolean;
};

const AmountField = ({
  onChange,
  buttonColor,
  min,
  max,
  size,
  fullWidth,
  value,
  disabled = false,
  isHidden,
  sx,
  error,
}: Props) => {
  if (isHidden) return null;

  return (
    <TextField
      name="amount"
      fullWidth={fullWidth}
      sx={{
        textAlign: "center",
        ...sx,
      }}
      disabled={disabled}
      type="tel"
      value={value}
      error={error}
      onChange={(e) => {
        // set value by typing
        const value = +e.target.value;

        if (
          onChange &&
          !isNaN(value) &&
          (min === undefined || value >= min) &&
          (max === undefined || value <= max)
        )
          return onChange(value);
      }}
      size={size}
      inputProps={{ style: { textAlign: "center" } }}
      InputProps={{
        sx: {
          backgroundColor: "#F9F9FA99",
          paddingLeft: "4px",
          paddingRight: "4px",
        },
        startAdornment: (
          <IconButton
            sx={{
              color: buttonColor || "rgba(0, 0, 0, 0.38)",
              "&:hover": { backgroundColor: "transparent" },
            }}
            disabled={disabled || value === min}
            onClick={() => {
              if (min === undefined || value > min) return onChange(value - 1);
            }}
          >
            <RemoveIcon />
          </IconButton>
        ),
        endAdornment: (
          <IconButton
            sx={{
              color: buttonColor || "rgba(0, 0, 0, 0.38)",
              "&:hover": { backgroundColor: "transparent" },
            }}
            disabled={disabled || value === max}
            onClick={() => {
              if (max === undefined || value < max) return onChange(value + 1);
            }}
          >
            <AddIcon />
          </IconButton>
        ),
      }}
    />
  );
};

export default AmountField;
